<div class="padding bg-light-blue">
	<div class="flex center">Templates</div>
</div>

<div class="padding">
	<div class="flex margin-bottom">
		<div class="flex-1 flex center">
			<h4>Search Templates</h4>
		</div>
	</div>

	<div class="chip-container flex wrap">
		@for (element of filtersList; track element) {
			@let label = getLabel(element.id);
			<div (click)="openDialogFilter(element.id)" class="filter-chip" [ngClass]="!label ? ' ' : 'selected'" [title]="getFullTitleFilter(element.id)">
				@if (label) {
					<b>{{ element.label }}</b>
					: {{ label }}
					<mat-icon (click)="clearFilter($event, element.id)">close</mat-icon>
				} @else {
					{{ element.label }}
					<mat-icon>edit</mat-icon>
				}
			</div>
		}
	</div>

	<bt-loader [loaderId]="loaderId">
		<div class="page-layout margin-large">
			@if (templates.data) {
				<div class="flex margin-bottom center">
					<div class="flex-1">
						@for (b of brandsFiltersSelected.cached; track b) {
							@if (!b.categories.length) {
								<span class="chip margin-smallest">
									{{ b.brandName }} - All categ.
									<i class="fa fa-times margin-left-small" (click)="removeBrandFilter(b)"></i>
								</span>
							} @else {
								@for (c of b.categories; track c) {
									<span class="chip margin-smallest">
										{{ b.brandName }} - {{ c.categoryName }}
										<i class="fa fa-times margin-left-small" (click)="removeBrandFilter(b, c)"></i>
									</span>
								}
							}
						}
					</div>

					<div class="flex-0">
						<button class="margin-right-small" [disabled]="!!templates.tmp" (click)="openTemplateForm()" *btHasRole="editRoles">
							<i class="fa fa-plus"></i>
							Create template
						</button>
					</div>
				</div>
				@if (templates.dataToView?.length) {
					@for (t of templates.dataToView; track t) {
						<div
							class="border margin-bottom-small padding-small"
							inViewport
							(inViewportAction)="inViewportAction($event, t)"
							[@opacityAnimation]="t.isVisible ? 'show' : 'hide'">
							<details [open]="t.openedDetails">
								<summary class="hover" (click)="onClickTemplate(t)">
									<div class="flex center">
										<div class="flex-1">
											<span class="bold">{{ t.templateName }}</span>
											<div class="grey margin-top-smallest">
												{{ templates.tmp ? templates.tmp.shotTypes.length : t.shotTypes.length }}
												shot types
											</div>
										</div>
										<div class="arrows padding-small">
											<i class="fa fa-chevron-down"></i>
											<i class="fa fa-chevron-up"></i>
										</div>
									</div>
								</summary>
								@if (t.openedDetails) {
									<div class="margin-top margin-bottom flex">
										<div class="flex-1 margin-left-smallest margin-right-smallest">
											<div class="margin-bottom-small">Brand</div>
											@if (t.inEditing && templates.tmp && !templates.tmp.templateId) {
												<bt-autocomplete
													[datasource]="brands.data"
													[settings]="brands.autocompleteSettings"
													(selected)="onSelectBrand($event)"
													[loaderId]="brands.loaderId"></bt-autocomplete>
											}
											@if (!t.inEditing || (!!templates.tmp && !!templates.tmp.templateId)) {
												<div class="card bold">{{ t.brandName }}</div>
											}
										</div>
										<div class="flex-1 margin-left-smallest margin-right-smallest">
											<div class="margin-bottom-small">Category</div>
											@if (t.inEditing && templates.tmp && !templates.tmp.templateId) {
												<bt-autocomplete
													[datasource]="categories.data"
													[settings]="categories.autocompleteSettings"
													[disabledProperty]="!templates.tmp.brandId"
													[loaderId]="categories.loaderId"
													(selected)="onSelectCategory($event)"></bt-autocomplete>
											}
											@if (!t.inEditing || (!!templates.tmp && !!templates.tmp.templateId)) {
												<div class="card bold">{{ t.categoryName || '- All categories -' }}</div>
											}
										</div>
										<div class="flex-1 margin-left-smallest margin-right-smallest">
											<div class="margin-bottom-small">Styles</div>
											@if (t.inEditing && templates.tmp && !templates.tmp.templateId) {
												<bt-multiselect
													[datasource]="styles.data"
													[nextDatasource]="styles.nextData"
													[settings]="styles.multiselectSettings"
													[disabled]="
														templates.tmp.categoryId === undefined ||
														templates.tmp.categoryId === null
													"
													[currentSelections]="templates.tmp.styles"
													[page]="styles.page"
													[loaderId]="styles.loaderId"
													[itemTemplate]="styleItemTemplate"
													[showOptions]="showStylesOptions"
													(open)="showStylesOptions = true"
													(selections)="onSelectStyles($event)"
													(nextPage)="onMultiselectNextpage()"
													(filterChange)="onMultiselectFilterChange($event)"></bt-multiselect>
											}
											@if (!t.inEditing || (!!templates.tmp && !!templates.tmp.templateId)) {
												<ng-container>
													@if (t.styles.length) {
														<div class="card">
															<b>
																{{
																	t.styles[0].styleCode +
																		' - ' +
																		t.styles[0].styleName
																}}
															</b>
															@if (t.styles.length > 1) {
																<span>
																	and
																	<b>{{ t.styles.length - 1 }}</b>
																	other{{ t.styles.length > 2 ? 's' : '' }}
																</span>
															}
														</div>
													} @else {
														<div class="card bold">- All styles -</div>
													}
												</ng-container>
											}
										</div>
										@if ((!t.inEditing || (!!templates.tmp && !!templates.tmp.templateId)) && t.styles.length === 1) {
											<div class="flex-1 margin-left-smallest margin-right-smallest">
												<div class="margin-bottom-small">Colors</div>
												@if (t.colors.length) {
													<div class="card relative pointer">
														<b>
															{{ t.colors[0].colorCode + ' - ' + t.colors[0].colorName }}
														</b>
														@if (t.colors.length > 1) {
															<span>
																and
																<b>{{ t.colors.length - 1 }}</b>
																other{{ t.colors.length > 2 ? 's' : '' }}
															</span>
														}
														<div class="card card-details padding-small to-show">
															@for (c of t.colors; track c) {
																<div class="truncate">{{ c.fullName }}</div>
															}
														</div>
													</div>
												} @else {
													<div class="card bold">- All colors -</div>
												}
											</div>
										}
										@if (t.inEditing && templates.tmp && !templates.tmp.templateId) {
											<div class="flex-1 margin-left-smallest margin-right-smallest">
												<div class="margin-bottom-small flex center">
													<span class="flex-1">Colors</span>
													<div
														class="info-icon flex-0 padding-left-small padding-right-small pointer">
														<i class="fa fa-info"></i>
														<div class="card padding-small">
															You can specify the colors by selecting a single style
														</div>
													</div>
												</div>
												<bt-multiselect
													[datasource]="colors.data"
													[nextDatasource]="colors.nextData"
													[settings]="colors.multiselectSettings"
													[disabled]="!templates.tmp.styles || templates.tmp.styles.length !== 1"
													[currentSelections]="templates.tmp.colors"
													[page]="colors.page"
													[loaderId]="colors.loaderId"
													(selections)="onSelectColors($event)"
													(nextPage)="onColorsMultiselectNextpage()"
													(filterChange)="onColorsMultiselectFilterChange($event)"
													(open)="onOpenColorsMultiselect()"></bt-multiselect>
											</div>
										}
									</div>
								}
								<bt-loader [loaderId]="sizeGroups.loaderId">
									@if (t.inEditing && templates.tmp && !!templates.tmp.brandId) {
										<div
											class="flex center justify-end margin-bottom"
											[title]="templates.tmp.hasSizeGroup ? '' : 'Option not available for current brand'">
											<div class="margin-right-small">Different shot types for size groups</div>
											<label class="switch" [ngClass]="{ disabled: !templates.tmp.hasSizeGroup }">
												<input
													type="checkbox"
													[disabled]="!templates.tmp.hasSizeGroup"
													[(ngModel)]="differentShotsForSizeGroups"
													(change)="onDifferentShotsForSizeGroups()" />
												<span class="slider round"></span>
											</label>
										</div>
									}
									@if (t.brandId || (t.inEditing && templates.tmp && !!templates.tmp.brandId)) {
										<div class="flex center justify-between margin-bottom">
											<div>Shot types</div>
											<div>
												@if (t.inEditing && !differentShotsForSizeGroups) {
													<div class="action-text" (click)="onAddShotType()">
														<i class="fa fa-plus margin-right-small"></i>
														<span>Add shot type</span>
													</div>
												}
											</div>
										</div>
									}
									@if (!t.inEditing) {
										@for (type of t.shotTypes; track type; let i = $index) {
											@if (
												type.sizeGroupId !== undefined &&
												type.sizeGroupId !== null &&
												(!i || type.sizeGroupId !== t.shotTypes[i - 1].sizeGroupId)
											) {
												<div class="margin-bottom-small" [ngClass]="{ 'margin-top': !!i }">
													{{ type.sizeGroupName }}
												</div>
											}

											<div class="flex">
												<div
													class="card bold margin-left-smallest margin-right-smallest shot-type-card margin-bottom-smallest">
													{{ type.shotTypeCode }} - {{ type.shotTypeName }}
												</div>

												<div
													class="card bold margin-left-smallest margin-right-smallest shot-type-card margin-bottom-smallest">
													{{ getMediaTypeCode(type) }}
												</div>
												<div
													class="card bold margin-left-smallest margin-right-smallest shot-type-card margin-bottom-smallest">
													{{ getCodifiedUsedlabel(type) }}
												</div>
												<div
													class="card bold margin-left-smallest margin-right-smallest shot-type-card margin-bottom-smallest">
													{{ getAspectRatio(type) }}
												</div>
											</div>
										}
									}
									@if (t.inEditing && templates.tmp) {
										<ng-container>
											@if (t.inEditing && differentShotsForSizeGroups) {
												<div class="flex center margin-bottom padding-left-small">
													<input type="checkbox" [(ngModel)]="changeAllColumn" />
													<label
														class="padding-left-small pointer"
														(click)="changeAllColumn = !changeAllColumn">
														Check to change shot types on the same column by modifying one
													</label>
												</div>
											}
											@for (type of templates.tmp.shotTypes; track type; let i = $index) {
												<ng-container>
													@if (
														!!i &&
														type.sizeGroupId !== templates.tmp.shotTypes[i - 1].sizeGroupId
													) {
														<br />
													}
													@if (
														type.sizeGroupId !== undefined &&
														type.sizeGroupId !== null &&
														(!i ||
															type.sizeGroupId !==
																templates.tmp.shotTypes[i - 1].sizeGroupId)
													) {
														<div
															class="margin-bottom-small flex center justify-between"
															[ngClass]="{ 'margin-top': !!i }">
															<div>{{ type.sizeGroupName }}</div>
															<div class="flex center">
																<div
																	class="action-text warning margin-right"
																	[ngClass]="{
																		'action-disabled':
																			sizeGroups.disabledDeleteAction
																	}"
																	(click)="onRemoveSizeGroup(type)">
																	<i
																		class="fa fa-trash margin-right-small"></i>
																	<span>Remove size group</span>
																</div>
																<div
																	class="action-text"
																	[ngClass]="{
																		'action-disabled':
																			templates.tmp.shotTypes[
																				i + maxShotTypes - 1
																			] &&
																			type.sizeGroupId ===
																				templates.tmp
																					.shotTypes[
																					i +
																						maxShotTypes -
																						1
																				].sizeGroupId
																	}"
																	(click)="onAddShotType(i)">
																	<i
																		class="fa fa-plus margin-right-small"></i>
																	<span>Add shot type</span>
																</div>
															</div>
														</div>
													}
													<div class="shot-type-card margin-bottom-smallest flex center">
														<div class="flex">
															<!-- Shot Type -->
															<div class="flex center">
																<button
																	class="icon-button"
																	[disabled]="
																		templates.tmp.shotTypes.length === 1
																	"
																	(click)="onRemoveShotType(i)">
																	<i class="fa fa-trash warning"></i>
																</button>
																<div class="flex-1 flex relative">
																	<input
																		type="text"
																		class="code margin-left-smallest margin-right-small"
																		placeholder="Code"
																		[ngClass]="{
																			incomplete:
																				tryToSave &&
																				!type.shotTypeCode
																		}"
																		[(ngModel)]="type.shotTypeCode"
																		(ngModelChange)="
																			onChangeShotTypeCode(type)
																		"
																		(focus)="onFocusShotType(i)"
																		(blur)="onBlurShotType(i)" />
																	<input
																		type="text"
																		class="name margin-right-small"
																		placeholder="Name"
																		[(ngModel)]="type.shotTypeName"
																		(ngModelChange)="
																			onChangeShotTypeName(type)
																		"
																		(focus)="onFocusShotType(i)"
																		(blur)="onBlurShotType(i)" />
																	@if (type.showOptions) {
																		<div
																			class="options-container"
																			(mouseenter)="
																				optionsHover = true
																			"
																			(mouseleave)="
																				optionsHover = false
																			">
																			<bt-loader
																				[loaderId]="
																					shotTypes.loaderId
																				">
																				<input
																					class="full-width"
																					type="text"
																					placeholder="Search..."
																					[(ngModel)]="
																						shotTypes.search
																					"
																					(ngModelChange)="
																						onShotTypesFilterChange()
																					"
																					(click)="
																						$event.stopPropagation()
																					" />
																				@if (
																					shotTypes
																						.data
																						?.length
																				) {
																					<div
																						class="overflow-container">
																						@for (
																							st of shotTypes.data;
																							track st
																						) {
																							<div
																								class="pointer hover flex center padding-small"
																								inViewport
																								(inViewportAction)="
																									shotTypesInViewportAction(
																										$event,
																										st
																									)
																								"
																								(click)="
																									onSelectShotType(
																										st
																									)
																								">
																								{{
																									st.code
																								}}{{
																									st.name
																										? ' - ' +
																											st.name
																										: ''
																								}}
																							</div>
																						}
																						@if (
																							shotTypes.data &&
																							!shotTypes
																								.data
																								.length
																						) {
																							<div
																								class="padding align-center"
																								(click)="
																									type.showOptions = false
																								">
																								There
																								are
																								no
																								data
																							</div>
																						}
																					</div>
																				}
																			</bt-loader>
																		</div>
																	}
																</div>
															</div>

															<!-- Media Type -->
															<div class="flex center">
																<div class="flex-1 flex relative">
																	<input
																		type="text"
																		class="code margin-left-smallest margin-right-small"
																		style="width: 120px"
																		placeholder="Format"
																		[ngClass]="{
																			incomplete:
																				tryToSave &&
																				!type.mediaFormatId
																		}"
																		[value]="
																			getMediaTypeLabel(
																				type.mediaFormatId
																			)
																		"
																		(input)="
																			type.mediaFormatId =
																				$event.target.value
																		"
																		(ngModelChange)="
																			onChangeMediaType(type)
																		"
																		(focus)="onFocusMediaType(i)"
																		(blur)="onBlurMediaType(i)" />
																	@if (type.showFormat) {
																		<div
																			class="options-container"
																			(mouseenter)="
																				optionsHover = true
																			"
																			(mouseleave)="
																				optionsHover = false
																			">
																			<bt-loader
																				[loaderId]="
																					mediaTypes.loaderId
																				">
																				<input
																					class="full-width"
																					type="text"
																					placeholder="Search..."
																					(ngModelChange)="
																						onMediaTypesFilterChange(
																							$event
																						)
																					"
																					(click)="
																						$event.stopPropagation()
																					" />
																				@if (
																					mediaTypes
																						.data
																						.length
																				) {
																					<div
																						class="overflow-container">
																						@for (
																							mediaType of mediaTypes.data;
																							track mediaType.id
																						) {
																							<!-- (inViewportAction)="shotTypesInViewportAction($event, type)" -->
																							<div
																								class="pointer hover flex center padding-small"
																								inViewport
																								(click)="
																									onSelectMediaType(
																										type,
																										mediaType
																									)
																								">
																								{{
																									mediaType.code
																								}}
																							</div>
																						}
																						@if (
																							mediaTypes.data &&
																							!mediaTypes
																								.data
																								.length
																						) {
																							<div
																								class="padding align-center"
																								(click)="
																									type.showOptions = false
																								">
																								There
																								are
																								no
																								data
																							</div>
																						}
																					</div>
																				}
																			</bt-loader>
																		</div>
																	}
																</div>
															</div>

															<!-- Utilizzo Codificato -->
															<div class="flex center">
																<div class="flex-1 flex relative">
																	<!-- [(ngModel)]="type.codifiedUsedCode" -->
																	<input
																		type="text"
																		class="code margin-left-smallest margin-right-small"
																		placeholder="Utilizzo Codificato"
																		[ngClass]="{
																			incomplete:
																				tryToSave &&
																				!type.codifiedUsedCode
																		}"
																		(input)="(type.codifiedUsedCode)"
																		[value]="getCodifiedUsedCode(type)"
																		(ngModelChange)="
																			onChangeCodifiedUsedCode(
																				type
																			)
																		"
																		(focus)="onFocusCodifiedUsed(i)"
																		(blur)="onBlurCodifiedUsed(i)" />

																	<!-- [(ngModel)]="type.codifiedUsedName"  -->
																	<input
																		type="text"
																		class="name margin-right-small"
																		placeholder="Name"
																		(input)="(type.codifiedUsedName)"
																		[value]="getCodifiedUsedDesc(type)"
																		(ngModelChange)="
																			onChangeCodifiedUsedName(
																				type,
																				$event
																			)
																		"
																		(focus)="onFocusCodifiedUsed(i)"
																		(blur)="onBlurCodifiedUsed(i)" />

																	@if (type.showCodifiedUsedsOptions) {
																		<div
																			class="options-container"
																			(mouseenter)="
																				optionsHover = true
																			"
																			(mouseleave)="
																				optionsHover = false
																			">
																			<bt-loader
																				[loaderId]="
																					shotTypes.loaderId
																				">
																				<input
																					class="full-width"
																					type="text"
																					placeholder="Search..."
																					(ngModelChange)="
																						onCodifiedUsedsFilterChange(
																							$event
																						)
																					"
																					(click)="
																						$event.stopPropagation()
																					" />
																				@if (
																					codifiedUseds
																						.data
																						.length
																				) {
																					<div
																						class="overflow-container">
																						@for (
																							codifiedUsed of codifiedUseds.data;
																							track codifiedUsed.id
																						) {
																							<!-- (inViewportAction)="shotTypesInViewportAction($event, type)" -->
																							<div
																								class="pointer hover flex center padding-small"
																								inViewport
																								[ngClass]="
																									isCodifiedUsedSelected(
																										codifiedUsed.id,
																										type
																									)
																										? 'div-disabled'
																										: ''
																								"
																								(click)="
																									onSelectCodifiedUsed(
																										type,
																										codifiedUsed
																									)
																								">
																								{{
																									codifiedUsed.code
																								}}{{
																									codifiedUsed.description
																										? ' - ' +
																											codifiedUsed.description
																										: ''
																								}}
																							</div>
																						}
																						@if (
																							codifiedUseds.data &&
																							!codifiedUseds
																								.data
																								.length
																						) {
																							<div
																								class="padding align-center"
																								(click)="
																									type.showOptions = false
																								">
																								There
																								are
																								no
																								data
																							</div>
																						}
																					</div>
																				}
																			</bt-loader>
																		</div>
																	}
																</div>
															</div>

															<!-- Aspect Ratio -->
															<div class="flex center">
																<div class="flex-1 flex relative">
																	<input
																		type="text"
																		class="code margin-left-smallest margin-right-small"
																		style="width: 120px"
																		placeholder="Aspect Ratio"
																		[ngClass]="{
																			incomplete:
																				tryToSave &&
																				!type.aspectRatioId
																		}"
																		[value]="
																			getAspectRatioLabel(
																				type.aspectRatioId
																			)
																		"
																		(input)="
																			type.aspectRatioId =
																				$event.target.value
																		"
																		(ngModelChange)="
																			onChangeAspectRatio(type)
																		"
																		(focus)="onFocusAspectRatio(i)"
																		(blur)="onBlurAspectRatio(i)" />
																	@if (type.showAspectRatio) {
																		<div
																			class="options-container"
																			(mouseenter)="
																				optionsHover = true
																			"
																			(mouseleave)="
																				optionsHover = false
																			">
																			<bt-loader
																				[loaderId]="
																					shotTypes.loaderId
																				">
																				<input
																					class="full-width"
																					type="text"
																					placeholder="Search..."
																					(ngModelChange)="
																						onAspectRatiosFilterChange(
																							$event
																						)
																					"
																					(click)="
																						$event.stopPropagation()
																					" />
																				@if (
																					aspectRatios
																						.data
																						.length
																				) {
																					<div
																						class="overflow-container">
																						@for (
																							aspectRatio of aspectRatios.data;
																							track aspectRatio.id
																						) {
																							<!-- (inViewportAction)="shotTypesInViewportAction($event, type)"  -->
																							<div
																								class="pointer hover flex center padding-small"
																								inViewport
																								(click)="
																									onSelectAspectRatio(
																										type,
																										aspectRatio
																									)
																								">
																								{{
																									aspectRatio.code
																								}}
																							</div>
																						}
																						@if (
																							aspectRatios.data &&
																							!aspectRatios
																								.data
																								.length
																						) {
																							<div
																								class="padding align-center"
																								(click)="
																									type.showOptions = false
																								">
																								There
																								are
																								no
																								data
																							</div>
																						}
																					</div>
																				}
																			</bt-loader>
																		</div>
																	}
																</div>
															</div>
														</div>
													</div>
												</ng-container>
											}
										</ng-container>
									}
									@if (t.inEditing && differentShotsForSizeGroups) {
										<ng-container>
											<div class="margin-top">Add size group</div>
											<div class="flex center margin-top-small">
												<div class="margin-right-small">
													<select [(ngModel)]="sizeGroups.selected" [disabled]="!sizeGroups.data">
														@if (sizeGroups.data?.length) {
															<ng-container>
																@for (s of sizeGroups.data; track s) {
																	<option
																		[ngValue]="s"
																		[disabled]="s.disabled">
																		{{ s.name }}
																	</option>
																}
															</ng-container>
														}
														@if (sizeGroups.data && !sizeGroups.data) {
															<option disabled>
																<div class="margin">No available size groups</div>
															</option>
														}
													</select>
												</div>
												<div class="flex-0">
													<button [disabled]="!sizeGroups.selected" (click)="addSizeGroup()">
														<i class="fa fa-plus"></i>
														Add
													</button>
												</div>
											</div>
										</ng-container>
									}
									<div class="margin-top flex column end">
										<div class="flex center">
											@if (!t.inEditing) {
												<ng-container *btHasRole="editRoles">
													<button
														class="margin-right-small stroked red"
														(click)="onDeleteTemplate(t)"
														[disabled]="!!templates.tmp || t.isDefault">
														<i class="fa fa-trash"></i>
														Delete template
													</button>
													<button (click)="openTemplateForm(t)" [disabled]="!!templates.tmp">
														<i class="fa fa-pencil"></i>
														Edit shot types
													</button>
												</ng-container>
											}
											@if (t.inEditing && !!templates.tmp) {
												<ng-container>
													<button class="margin-right-small" (click)="cancelEditTemplate(t)">
														<i class="fa fa-close"></i>
														Cancel {{ !templates.tmp.templateId ? 'template' : 'changes' }}
													</button>
													<button
														[loaderId]="updateLoaderId"
														[disabled]="!templates.tmp || !templates.tmp.brandId"
														(click)="onSaveTemplate()">
														<i class="fa fa-save"></i>
														Save changes
													</button>
												</ng-container>
											}
										</div>
									</div>
								</bt-loader>
							</details>
						</div>
					}
				}
				@if (templates.dataToView && !templates.dataToView.length) {
					<div class="padding-large flex column center grey margin-top-large">
						<i class="fa fa-search big margin-bottom-smallest"></i>
						<h4>No data found</h4>
					</div>
				}
			}
		</div>
	</bt-loader>

	@if (currentSidebar === sidebarTypeEnum.deleteAction) {
		<bt-sidebar sidebarTitle="Delete template" (exit)="onExitSidebar()">
			@if (templates.tmp) {
				<div class="flex overflow column">
					<div class="flex-0 padding-top-large padding-bottom-large">Are you sure you want to selected template?</div>
					<div class="flex-1 overflow padding-smallest">
						<div class="margin-bottom-small">Brand</div>
						<div class="card bold margin-bottom">{{ templates.tmp.brandName }}</div>
						<div class="margin-bottom-small">Category</div>
						<div class="card bold margin-bottom">{{ templates.tmp.categoryName || '- All categories -' }}</div>
						<div class="margin-bottom-small">Styles</div>
						@if (templates.tmp.styles.length) {
							<div class="card">
								<b>{{ templates.tmp.styles[0].styleCode + ' - ' + templates.tmp.styles[0].styleName }}</b>
								@if (templates.tmp.styles.length > 1) {
									<span>
										and
										<b>{{ templates.tmp.styles.length - 1 }}</b>
										other{{ templates.tmp.styles.length > 2 ? 's' : '' }}
									</span>
								}
							</div>
						} @else {
							<div class="card bold">- All styles -</div>
						}
					</div>
					<div class="flex-0">
						<button class="full-width warning" [loaderId]="sidebarLoaderId" (click)="deleteTemplate()">
							<i class="fa fa-trash"></i>
							Detele template
						</button>
					</div>
				</div>
			}
		</bt-sidebar>
	}

	<ng-template #styleItemTemplate let-item let-index>
		<div class="flex center">
			<div class="flex-1 truncate">{{ item.fullName }}</div>
			<i
				class="flex-0 margin-left-small fa fa-eye"
				[ngClass]="{ 'disable-icon': !item.sketchImgPath }"
				[title]="!item.sketchImgPath ? 'Sketch not available' : 'View sketch'"
				(click)="onStyleSketch($event, item)"></i>
		</div>
	</ng-template>
</div>
